module.exports = (($) => {
    class NavbarSearch {}
    $('#navbar-search-input').autocomplete({
            templates: {
                dropdownMenu: '#navbar-search-custom-menu-template'
            },
            hint: false,
            clearOnSelected: true,
            autoselect: true,
            debug: false,
            openOnFocus: true
        },
        [
        {
            source: function(query, callback) {
                if (typeof window.ajaxSerachProjects !== 'undefined') {
                    window.ajaxSerachProjects.abort();
                }
                window.ajaxSerachProjects = $.getJSON("/search/projects?q=" + query, function(data) {
                    delete window.ajaxSerachProjects;
                    callback(data.data);
                    $('.aa-dataset-d1 .counter').html(data.metadata.total);
                });
            },
            name: 'd1',
            displayKey: 'name',
            templates: {
                header: '<p><b>Projekte</b> <span class="counter"></span></p>',
                suggestion: function(suggestion) {
                    return '<p>' + suggestion.name + '<br><span class="text-muted small">' + suggestion.subname + '</span></p>';
                }
            }
        }, {
            source: function(query, callback) {
                if (typeof window.ajaxSearchSequnces !== 'undefined') {
                    window.ajaxSearchSequnces.abort();
                }
                window.ajaxSearchSequnces = $.getJSON("/search/sequences?q=" + query, function(data) {
                    delete window.ajaxSearchSequnces;
                    callback(data.data);
                    $('.aa-dataset-d2 .counter').html(data.metadata.total);
                });
            },
            name: 'd2',
            displayKey: 'name',
            templates: {
                header: '<p><b>Züge</b> <span class="counter"></span></p>',
                suggestion: function(suggestion) {
                    return '<p>' + suggestion.name + '<br><span class="text-muted small">' + suggestion.subname + '</span></p>';
                }
            }
        }
        // , {
        //     source: function(query, callback) {
        //         if (typeof window.ajaxSearchProzessess !== 'undefined') {
        //             window.ajaxSearchProzessess.abort();
        //         }
        //         window.ajaxSearchProzessess = $.getJSON("/search/prozesses?q=" + query, function(data) {
        //             delete window.ajaxSearchProzessess;
        //             callback(data.data);
        //             $('.aa-dataset-d3 .counter').html(data.metadata.total);
        //         });
        //     },
        //     name: 'd3',
        //     displayKey: 'name',
        //     templates: {
        //         header: '<p><b>Abteile</b> <span class="counter"></span></p>',
        //         suggestion: function(suggestion) {
        //             return '<p>' + suggestion.name + '<br><span class="small">'+suggestion.tasks+'</span><br><span class="text-muted small">' + suggestion.subname + '</span></p>';
        //         }
        //     }
        // }
        ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
            console.log(event, suggestion, dataset, context);
            window.location = suggestion.url;
            $('#navbar-search-input').blur();
        });
    return NavbarSearch
})(jQuery)
